module.exports = __webpack_public_path__ + "static/media/OH2@2x.8905a67a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OH/OH2@2x.png
// module id = 703
// module chunks = 0